import _ from 'underscore';

angular.module('am4')
.factory('elasticList', function() {

    // Tree node objects - contains value and refs to children
    function Node(value) {
        this.value = value;
        this.children = {};
    }

    // //Tree Leaf object - contains value to identify by and item data
    // function Leaf(value, data) {
    //     this.value = value;
    //     this.data = data;
    // }

    var statusDictionary = {
        ONLINE: 1,
        NOT_ONLINE: 2,
        HAS_ERROR_CODE: 4,
        NOT_HAS_ERROR_CODE: 8,
        HAS_SERVICE_CODE: 16,
        NOT_HAS_SERVICE_CODE: 32,
        HEALTHY: 64,
        UNHEALTHY: 128,
        ACTIVE: 256,
        INACTIVE: 512
    };

    function statusFromEquip(equip, includeActive) {
        var statusCombo = equip.online +
            (!equip.online << 1) +
            ((equip.error_code > 0) << 2) +
            ((equip.error_code === 0) << 3) +
            ((equip.service_code > 0) << 4) +
            ((equip.service_code === 0) << 5) +
            (equip.healthy << 6) +
            (!equip.healthy << 7);

        if (includeActive) {
            statusCombo += (equip.is_active << 8) + (!equip.is_active << 9);
        }
        return statusCombo;
    }

    function statusFromOptions(options) {
        return _.reduce(options, function(memo, option) {
            return memo + statusDictionary[option] || 0;
        }, 0);
    }

    function getAvailableStatusIntersections(intersections) {
        return _.reduce(statusDictionary, function(memo, v, k) {
            if (_.find(intersections, function(stat) {
                return v & +stat;
            })) {
                memo.push(k);
            }

            return memo;
        }, []);
    }

    // Class Constructor
    function ElasticListTree(data, includeActive) {
        // creates root node
        this.root = new Node('Root');

        // treeOptions contains the options utilized by the most recent query
        // Any terms/facets that create issues are removed by the search function
        this.treeOptions = {
            organization_id: [],
            facility_id: [],
            machine_type_code: [],
            series: [],
            status: []
        };

        this.defaultOptions = JSON.parse(JSON.stringify(this.treeOptions));

        // Contains the available options for any given state of the data
        this.availableOptions = {
            organization_id: [],
            facility_id: [],
            machine_type_code: [],
            series: [],
            status: {}
        };

        this.hierarchy = ['organization_id', 'facility_id', 'machine_type_code', 'series'];

        var that = this;
        // for each piece of equipment
        _.each(data, function(equip) {
            // for each facet, Select the ref to the existing node or make a new node
            var org = that.root.children[equip.organization_id] || new Node(equip.organization_id),
                fac = org.children[equip.facility_id] || new Node(equip.facility_id),
                machType = fac.children[equip.machine_type_code] || new Node(equip.machine_type_code),
                series = machType.children[equip.series] || new Node(equip.series),

                statusVal = statusFromEquip(equip, includeActive),
                status = series.children[statusVal] || new Node(statusVal);

            // var equipNode = new Leaf(equip.frame_serial, equip);

            // set up the tree node structure by putting each of the above nodes as children
            // of each other if not already set up like that
            if (!that.root.children[equip.organization_id]) {
                that.root.children[equip.organization_id] = org;
            }
            if (!org.children[equip.facility_id]) {
                org.children[equip.facility_id] = fac;
            }
            if (!fac.children[equip.machine_type_code]) {
                fac.children[equip.machine_type_code] = machType;
            }
            if (!machType.children[equip.series]) {
                machType.children[equip.series] = series;
            }
            if (!series.children[statusVal]) {
                series.children[statusVal] = status;
            }
            // finally set the child node as the leaf to this set of branches
            status.children[equip.frame_serial] = equip;

            that.availableOptions.organization_id.push(equip.organization_id);
            that.availableOptions.facility_id.push(equip.facility_id);
            that.availableOptions.machine_type_code.push(equip.machine_type_code);
            that.availableOptions.series.push(equip.series);
            that.availableOptions.status[statusVal] = true;
        });

        that.availableOptions.organization_id = _.uniq(that.availableOptions.organization_id);
        that.availableOptions.facility_id = _.uniq(that.availableOptions.facility_id);
        that.availableOptions.machine_type_code = _.uniq(that.availableOptions.machine_type_code);
        that.availableOptions.series = _.uniq(that.availableOptions.series);
        that.availableOptions.status =
            getAvailableStatusIntersections(_.keys(that.availableOptions.status));
    }

    ElasticListTree.prototype.treeSearch = function(options) {
        var that = this,
            // set first level as the root's children
            children = _.values(that.root.children);

        // set proposed options object to treeOptions
        that.treeOptions = _.clone(options);

        // Iteratively perform a modified breadth first seach on this tree
        _.each(that.hierarchy, function(index) {


            var level = options[index],
                // temp variable to add next children to be evaluated to
                temp = [],
                // varible to add the facets that have already been found on the level
                used = [];

            // Available options are the unique option values children
            that.availableOptions[index] = _.uniq(_.pluck(children, 'value'));
            // for each child node...
            _.each(children, function(node) {
                // if there are no restrictions on the search at this level of the tree,
                // just put all children in the temp object
                if (level.length === 0) {
                    temp = temp.concat(_.values(node.children));
                } else if (_.indexOf(level, node.value) > -1) {
                    // otherwise if the value of the node is found, then push the children
                    // into temp and push the value into the used facets array
                    temp = temp.concat(_.values(node.children));
                    used.push(String(node.value));
                }
            });
            // if we find that the number of used facets is less than the number of facets being
            // used at that point in the tree, that means there is at least one "impossible" node
            // being searched for. If this occurs, the treeOptions at this particular level in the
            // tree are replaced by used array, or the nodes it was possible to reach.
            if (used.length < level.length) {
                that.treeOptions[index] = used;
            }
            // finally, the children array is replaced by the new children stemming from this
            // level of the tree
            children = temp;
        });

        that.availableOptions.status = getAvailableStatusIntersections(_.uniq(_.pluck(children, 'value')));
        that.treeOptions.status = _.reduce(that.treeOptions.status, function(memo, option) {
            if (_.contains(that.availableOptions.status, option)) {
                memo.push(option);
            }

            return memo;
        }, []);

        // Finally we create a result list of the leaf elements
        let statusOptions;
        if (options.status && options.status.length > 0) {
            statusOptions = statusFromOptions(options.status);
            children = _.reduce(children, function(memo, node) {
                // Yes, this is supposed to be a bitwise operation
                if ((statusOptions & node.value) === statusOptions) {
                    return memo.concat(_.values(node.children));
                }
                return memo;

            }, []);
        } else {
            // children should be series level, which we will just grab all the children
            children = _.reduce(children, function(memo, node) {
                return memo.concat(_.values(node.children));
            }, []);
        }

        // If we find that after this iteration that not all desired selections were possible,
        // we repeat the search with the possible TreeOptions
        if (!_.isEqual(that.treeOptions, options)) {
            return that.treeSearch(that.treeOptions);
        }
        // otherwise we return the leaf nodes
        return children;
    };

    return function(data, includeActive) {
        return new ElasticListTree(data, includeActive);
    };

});



// WEBPACK FOOTER //
// ./src/app/services/elasticList.js